import { authorizedFetch } from "./base";
import { BillingStatus, SubscriptionDetails } from "./types";

export async function startTrial(plan: "monthly" | "yearly"): Promise<string> {
  const { url } = await authorizedFetch<{ url: string }>(`/billing/checkout`, {
    method: "POST",
    body: JSON.stringify({ plan }),
  });
  return url;
}

export async function startBillingPortal(): Promise<string> {
  const { url } = await authorizedFetch<{ url: string }>(`/billing/portal`, {
    method: "POST",
  });
  return url;
}

export async function getBillingStatus(): Promise<BillingStatus> {
  return authorizedFetch<BillingStatus>("/me/billing");
}

export async function acknowledgeBillingInfo(): Promise<{ ok: boolean }> {
  return authorizedFetch<{ ok: boolean }>("/billing/acknowledge", {
    method: "POST",
  });
}

/** Records that the user answered the post-trial screen by staying on the free tier. */
export async function chooseFreeTier(): Promise<{ ok: boolean }> {
  return authorizedFetch<{ ok: boolean }>("/billing/choose-free", {
    method: "POST",
  });
}

/** Picks the portfolios a free user over the allowance keeps editable. Final until they pay. */
export async function pickFreeTierPortfolios(
  portfolioIds: number[],
): Promise<{ ok: boolean }> {
  return authorizedFetch<{ ok: boolean }>("/billing/free-tier-portfolios", {
    method: "POST",
    body: JSON.stringify({ portfolio_ids: portfolioIds }),
  });
}

export async function getSubscriptionDetails(): Promise<SubscriptionDetails> {
  return authorizedFetch<SubscriptionDetails>("/billing/subscription");
}

export async function cancelSubscription(): Promise<{ cancel_at_period_end: boolean }> {
  return authorizedFetch<{ cancel_at_period_end: boolean }>("/billing/cancel", {
    method: "POST",
  });
}

export async function upgradeToYearly(): Promise<{ status: string }> {
  return authorizedFetch<{ status: string }>("/billing/upgrade-to-yearly", {
    method: "POST",
  });
}
